import moment from "moment";

export default function sigoFormatDate(date) {
    var fechaMoment = moment(date, "YYYY-MM-DD HH:mm:ss");

    if (!fechaMoment.isValid()) return '-';

    return fechaMoment.format("DD/MM/YYYY");
}